import React from "react";
import { 
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col, 
    Nav, 
    NavItem, 
    NavLink, 
    Row,
    Table
} from "reactstrap";
import { Link } from "react-router-dom";

// Requests
import { getUnitRequest } from "api/units";
import { getBrokerRequest } from "api/broker";
import { getSellerRequest } from "api/seller";
// Helpers
import { formatUnitStatus } from "helpers/status";
import { formatPrice } from "helpers/pricing";
import { formatUnitOrietation } from "helpers/status";

class UnitDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unit: null,
            loading: true,
            activeTab: "information",
            commissionsWithNames: []
        };
    }

    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
    	const id = params.get("id");

		await this.getUnit(id)
	}

    getUnit = async (id) => {
        this.setState({loading: true})
		const unit = await getUnitRequest(id)

        // Load commission recipient data
        const commissionsWithNames = await this.loadCommissionRecipientData(unit.commissions || []);

		this.setState({
			unit,
            commissionsWithNames,
            loading: false
		})
	}

    goTo = path => this.props.history.push(path);

    loadCommissionRecipientData = async (commissions) => {
        const enrichedCommissions = await Promise.all(
            commissions.map(async (commission) => {
                if (commission.recipientType && commission.recipientId) {
                    try {
                        if (commission.recipientType === 'broker') {
                            const broker = await getBrokerRequest(commission.recipientId);
                            if (broker) {
                                return {
                                    ...commission,
                                    recipientName: broker.name,
                                    recipientData: broker
                                };
                            }
                        } else if (commission.recipientType === 'seller') {
                            const seller = await getSellerRequest(commission.recipientId);
                            if (seller) {
                                return {
                                    ...commission,
                                    recipientName: `${seller.first_name} ${seller.last_name}`,
                                    recipientData: seller
                                };
                            }
                        }
                    } catch (error) {
                        console.error('Error loading recipient data:', error);
                    }
                }
                return commission;
            })
        );
        return enrichedCommissions;
    }

    changeActiveTab = (e, tabState, tadName) => {
		e.preventDefault();	
		this.setState({
		  [tabState]: tadName,
		});
	};

    renderActiveTab = (tab) => {
		const {
			unit,
			commissionsWithNames
		} = this.state;

        const {
            _id,
            project,
            block_number,
            lot_number,
            lot_area,
            selectedModel,
            client,
            previousClient,
            models = [],
            status,
            sellerBonus,
            orientation
        } = unit || {};

		switch(tab) {
			case "information":
				return (
					<Row>
						<Col sm="8">
                            <div className="typography-line">
                                <h4>
                                    <span>ID</span>
                                    {_id}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Project</span>
                                    { project ?
                                        <Link to={`/project?id=${project._id}`}>
                                            {project.name} 
                                        </Link>
                                    :
                                        'N/A'
                                    }
                                </h4>
                            </div>
                            
                            <div className="typography-line">
                                <h4>
                                    <span>Block Number</span>
                                    {block_number || 'N/A'}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Lot Number</span>
                                    {lot_number || 'N/A'}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Lot Area</span>
                                    {lot_area || "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Orientation</span>
                                    {formatUnitOrietation(orientation) || "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Seller Bonus</span>
                                    {sellerBonus || "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Selected Model</span>
                                    {selectedModel?.name || "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Price</span>
                                    {selectedModel?.price ? `PHP ${formatPrice(selectedModel?.price)}` : 'N/A'}
                                </h4>
                            </div>
                            {selectedModel?.price && selectedModel?.discount 
                                ?
                                <>
                                    <div className="typography-line">
                                        <h4>
                                            <span>Discount</span>
                                            {`PHP ${formatPrice(selectedModel?.discount)}`}
                                        </h4>
                                    </div>
                                    <div className="typography-line">
                                        <h4>
                                            <span>Discount Details</span>
                                            {selectedModel?.discount_details || 'N/A'}
                                        </h4>
                                    </div>
                                    <div className="typography-line">
                                        <h4>
                                            <span>Price with discount</span>
                                            {`PHP ${formatPrice(selectedModel.price - selectedModel.discount)}`}
                                        </h4>
                                    </div>
                                </>
                                : null
                            }
                            <div className="typography-line">
                                <h4>
                                    <span>VAT</span>
                                    {selectedModel?.vat ? `PHP ${formatPrice(selectedModel?.vat)}` : 'N/A'}
                                </h4>
                            </div>
                            
                            <div className="typography-line">
                                <h4>
                                    <span>TCP</span>
                                    {selectedModel?.tcp ? `PHP ${formatPrice(selectedModel?.tcp)}` : 'N/A'}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Client</span>
                                    {client ? 
										<Link to={`/client?id=${client._id}`}>
											{`${client.first_name} ${client.last_name}`}
										</Link>
									:
										"N/A"
									}
                                </h4>
                            </div>
                            {previousClient &&
                                <div className="typography-line">
                                    <h4>
                                        <span>Previous Client</span>
                                        {previousClient ? 
                                            <Link to={`/previousClient?id=${client._id}`}>
                                                {`${previousClient.first_name} ${previousClient.last_name}`}
                                            </Link>
                                        :
                                            "N/A"
                                        }
                                    </h4>
                                </div>
                            }
                            <div className="typography-line">
                                <h4>
                                    <span>Status</span>
                                    {formatUnitStatus(status) || 'N/A'}
                                </h4>
                            </div>
						</Col>
					</Row>
				)
			case "models":
				return (
					<Table responsive>
						<thead className="text-primary">
							<tr>
								<th>Name</th>
								<th>Price</th>
								<th>VAT</th>
								<th>TCP</th>
								<th>Is available</th>
							</tr>
						</thead>
						<tbody>
							{models && models.length > 0 ?
								<>
									{models.map(model => (
									<tr>
										<td>{model.name || "N/A"}</td>
										<td>{model.price ? formatPrice(model?.price) : "N/A"}</td>
										<td>{model.vat ? formatPrice(model?.vat) :  "N/A"}</td>
										<td>{model.tcp ?  formatPrice(model?.tcp) : "N/A"}</td>
										<td>{model.notAvailable ?  'Is not available' : "Is available"}</td>
									</tr>
									))}
								</>
							: 	<tr>
									<td colSpan="4">This unit doesn't have any models yet</td>
								</tr>		
							}
						</tbody>
					</Table>
				)
			case "commissions":
				return (
					<Table responsive>
						<thead className="text-primary">
							<tr>
								<th>Recipient Type</th>
								<th>Recipient Name</th>
								<th>Percentage</th>
							</tr>
						</thead>
						<tbody>
							{commissionsWithNames && commissionsWithNames.length > 0 ?
								<>
									{commissionsWithNames.map((commission, index) => (
									<tr key={index}>
										<td>{commission.recipientType === 'broker' ? 'Broker' : commission.recipientType === 'seller' ? 'Seller' : 'Unknown'}</td>
										<td>
											{commission.recipientName || `ID: ${commission.recipientId}`}
										</td>
										<td>{commission.percentage ? `${commission.percentage}%` : "N/A"}</td>
									</tr>
									))}
									<tr className="font-weight-bold">
										<td colSpan="2">Total Commission</td>
										<td>{commissionsWithNames.reduce((sum, commission) => sum + (parseFloat(commission.percentage) || 0), 0).toFixed(2)}%</td>
									</tr>
								</>
							: 	<tr>
									<td colSpan="3">This unit doesn't have any commissions configured</td>
								</tr>		
							}
						</tbody>
					</Table>
				)
            default: return <p>Default case in renderActiveTab</p>
		}
	}

    render () {
        const {
            unit,
            loading,
            activeTab
        } = this.state

        const tabs = [
			{
				title: "Information",
				type: "information"
			},
			{
				title: "Models",
				type: "models"
			},
			{
				title: "Commissions",
				type: "commissions"
			},
		]

        return (
            <div className="content">
				<Row>
					<Col md="12">
						<Card>
							<CardHeader className="mb-5">
								<CardTitle tag="h3">
									Unit Details
                                    <Button
                                        className="float-right"
                                        color="default"
                                        onClick={() => this.goTo('/units')}
                                    >
                                        Back
                                    </Button>
                                </CardTitle>
                                <Nav className="nav-pills-info" pills>
									{tabs.map((tab) => {
										return (
											<NavItem key={tab.title}>
												<NavLink
												data-toggle="tab"
												href="#pablo"
												className={
													this.state.activeTab === tab.type
													? "active"
													: ""
												}
												onClick={(e) =>
													this.changeActiveTab(
													e,
													"activeTab",
													tab.type
													)
												}
												>
												{tab.title}
												</NavLink>
											</NavItem>
										)
									})}
								</Nav>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                {console.log(unit)}
                                    <Col>
                                        { loading ? 
                                                <h5>Loading...</h5>
                                            :
                                                this.renderActiveTab(activeTab)
                                            }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default UnitDetails